const DESKTOP_BREAKPOINT = 1280;
const menuSelector = '#header-main-nav-container #header-main-nav ul.menu';
const triggerSelector = `${menuSelector} li.children > a[href="#"], ${menuSelector} li.children > .sub-nav-toggler`;

const kkNavigationSubNav = function () {
    const setupNav = () => {
        if (window.innerWidth >= DESKTOP_BREAKPOINT) {
            document.querySelectorAll(`${menuSelector} .children.open`).forEach((item) => {
                item.classList.remove('open');
                const toggler = item.querySelector('.sub-nav-toggler');
                if (toggler) toggler.classList.remove('open');
            });
            const navContainer = document.getElementById('header-main-nav-container');
            if (navContainer) navContainer.classList.remove('open');
            const bgLayer = document.getElementById('bg-layer');
            if (bgLayer) bgLayer.classList.remove('!opacity-50');
        }

        if (window.innerWidth < DESKTOP_BREAKPOINT) {
            if (!$('header .navbar-toggler').hasClass('resize-initialized')) {
                $('header .navbar-toggler')
                    .addClass('resize-initialized')
                    .on('click', function (event) {
                        event.preventDefault();
                        const isOpening = !$('body').hasClass('open-nav');
                        $('html, body').toggleClass('open-nav');
                        $(this).toggleClass('open');
                        $('nav, header, #header-main-nav-container, #header-inner .wrapper').toggleClass('open');
                        window.dispatchEvent(new CustomEvent(isOpening ? 'main-nav-open' : 'main-nav-close'));
                    });
            }
        }

        // Submenu togglers: link with href="#" or .sub-nav-toggler button
        document.querySelectorAll(triggerSelector).forEach((element) => {
            if (element.classList.contains('resize-initialized')) return;
            element.classList.add('resize-initialized');

            element.addEventListener('click', function (e) {
                const parent = element.closest('.children');
                const navContainer = document.getElementById('header-main-nav-container');
                const bgLayer = document.getElementById('bg-layer');

                if (element.classList.contains('sub-nav-toggler')) {
                    const siblings = parent.parentElement?.querySelectorAll('.children') || [];
                    siblings.forEach((sibling) => {
                        if (sibling !== parent) {
                            sibling.classList.remove('open');
                            const siblingToggler = sibling.querySelector('.sub-nav-toggler');
                            if (siblingToggler) siblingToggler.classList.remove('open');
                        }
                    });

                    parent.classList.toggle('open');
                    element.classList.toggle('open', parent.classList.contains('open'));

                    e.stopPropagation();
                    e.preventDefault();
                    return;
                }

                if (parent.classList.contains('open')) {
                    parent.classList.remove('open');
                    if (parent.querySelector('.sub-nav-toggler')) {
                        parent.querySelector('.sub-nav-toggler').classList.remove('open');
                    }
                    const anyOpen = document.querySelectorAll(`${menuSelector} .children.open`).length > 0;
                    if (!anyOpen && navContainer) navContainer.classList.remove('open');
                    if (window.innerWidth > DESKTOP_BREAKPOINT && bgLayer) {
                        bgLayer.classList.remove('!opacity-50');
                    }
                } else {
                    const siblings = parent.parentElement?.querySelectorAll('.children') || [];
                    siblings.forEach((sibling) => {
                        if (sibling !== parent) {
                            sibling.classList.remove('open');
                            const toggler = sibling.querySelector('.sub-nav-toggler');
                            if (toggler) toggler.classList.remove('open');
                        }
                    });
                    parent.classList.add('open');
                    if (parent.querySelector('.sub-nav-toggler')) {
                        parent.querySelector('.sub-nav-toggler').classList.add('open');
                    }

                    const anyOpen = document.querySelectorAll(`${menuSelector} .children.open`).length > 0;
                    if (anyOpen) {
                        if (navContainer) navContainer.classList.add('open');
                        if (window.innerWidth > DESKTOP_BREAKPOINT && bgLayer) {
                            if (parent.classList.contains('mega-menu')) {
                                bgLayer.classList.add('!opacity-50');
                            } else {
                                bgLayer.classList.remove('!opacity-50');
                            }
                        }
                    }
                }

                e.stopPropagation();
                e.preventDefault();
            });
        });
    };

    // Close on scroll down
    if (!document.body.hasAttribute('data-nav-scroll-initialized')) {
        document.body.setAttribute('data-nav-scroll-initialized', 'true');
        let lastScrollY = window.scrollY || window.pageYOffset;
        const scrollThreshold = 30;

        window.addEventListener('scroll', () => {
            const currentScrollY = window.scrollY || window.pageYOffset;
            if (currentScrollY <= lastScrollY || currentScrollY - lastScrollY < scrollThreshold) {
                lastScrollY = currentScrollY;
                return;
            }
            lastScrollY = currentScrollY;

            const navContainer = document.getElementById('header-main-nav-container');
            const bgLayer = document.getElementById('bg-layer');

            // Close mobile nav
            if (window.innerWidth < DESKTOP_BREAKPOINT && document.body.classList.contains('open-nav')) {
                $('html, body').removeClass('open-nav');
                $('header .navbar-toggler').removeClass('open');
                $('nav, header, #header-main-nav-container, #header-inner .wrapper').removeClass('open');
                window.dispatchEvent(new CustomEvent('main-nav-close'));
            }

            // Close all open submenus
            document.querySelectorAll(`${menuSelector} .children.open`).forEach((item) => {
                item.classList.remove('open');
                const toggler = item.querySelector('.sub-nav-toggler');
                if (toggler) toggler.classList.remove('open');
            });
            if (navContainer) navContainer.classList.remove('open');
            if (bgLayer) bgLayer.classList.remove('!opacity-50');
        }, { passive: true });
    }

    // Close mobile nav when overlay requests close (Alpine openMainNav = false)
    if (!document.body.hasAttribute('data-nav-request-close-initialized')) {
        document.body.setAttribute('data-nav-request-close-initialized', 'true');
        window.addEventListener('main-nav-request-close', () => {
            if (!document.body.classList.contains('open-nav')) return;
            $('html, body').removeClass('open-nav');
            $('header .navbar-toggler').removeClass('open');
            $('nav, header, #header-main-nav-container, #header-inner .wrapper').removeClass('open');
            window.dispatchEvent(new CustomEvent('main-nav-close'));
        });
    }

    // Close mega menu when clicking outside (desktop)
    if (!document.body.hasAttribute('data-nav-body-initialized')) {
        document.body.setAttribute('data-nav-body-initialized', 'true');
        document.body.addEventListener('click', (e) => {
            if (window.innerWidth <= DESKTOP_BREAKPOINT) return;

            const bgLayer = document.getElementById('bg-layer');
            let isClickInsideMegaMenu = false;

            document.querySelectorAll(`${menuSelector} li.children.mega-menu > .level-1`).forEach((el) => {
                if (el.contains(e.target)) isClickInsideMegaMenu = true;
            });

            if (!isClickInsideMegaMenu) {
                if (bgLayer) bgLayer.classList.remove('!opacity-50');
                document.querySelectorAll(`${menuSelector} li.children.mega-menu.open`).forEach((mega) => {
                    mega.classList.remove('open');
                    const toggler = mega.querySelector('.sub-nav-toggler');
                    if (toggler) toggler.classList.remove('open');
                });
                const navContainer = document.getElementById('header-main-nav-container');
                if (navContainer && !document.querySelector(`${menuSelector} .children.open`)) {
                    navContainer.classList.remove('open');
                }
            }
        });
    }

    setupNav();
    window.addEventListener('resize', () => setupNav());
};

export { kkNavigationSubNav };
